import { render, staticRenderFns } from "./LicenseApplicationList.vue?vue&type=template&id=8a12be96&scoped=true&"
import script from "./LicenseApplicationList.vue?vue&type=script&lang=js&"
export * from "./LicenseApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a12be96",
  null
  
)

export default component.exports